export default __webpack_public_path__ + "img/7b6d4b0334c88919c54e8dcbdd3891ed.png";